<template>


	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Clientes" exibeVoltar="true" historyback="true" />
        </div>
        <div class="app-centro">
            <table class="table" cellpading="0" cellspacing="0">
                <tr>
                    <td class="label-cadastro">Nome:</td>
                    <td class="campo-cadastro"> {{cliente.NOME_CLIENTE}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Endereço:</td>
                    <td class="campo-cadastro"> {{cliente.ENDERECO}}</td>
                </tr>

                <tr>
                    <td class="label-cadastro">Cidade:</td>
                    <td class="campo-cadastro"> {{cliente.CIDADE}} <span v-if="cliente.ESTADO">- {{cliente.ESTADO}}</span></td>
                </tr>

                <tr>
                    <td class="label-cadastro">Email:</td>
                    <td class="campo-cadastro"> {{cliente.EMAIL}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Telefone:</td>
                    <td class="campo-cadastro"> {{cliente.TEL}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Fax:</td>
                    <td class="campo-cadastro"> {{cliente.FAX}} </td>
                </tr>

                <tr>
                    <td class="label-cadastro">Celular:</td>
                    <td class="campo-cadastro"> {{cliente.CELULAR}} </td>
                </tr>



                <!-- Marcos 14/10/2022 - WTI-10316 -->
                <tr>
                    <td class="label-cadastro">Dt. de Nascimento:</td>
                    <td class="campo-cadastro"> {{ cliente.DT_NASC | moment("DD/MM/YYYY") }} </td>
                </tr>

                <!-- Marcos 14/10/2022 - WTI-10316 -->
                <tr>
                    <td class="label-cadastro">
                        <div v-if="cliente.TIPO_FJ=='F'">Cpf:</div>
                        <div v-if="cliente.TIPO_FJ=='J'">Cnpj:</div>
                    </td>

                    <td class="campo-cadastro">
                        <div v-if="cliente.TIPO_FJ=='F'">{{cliente.CPF_CNPJ | toCpfFormatado}}</div>
                        <div v-if="cliente.TIPO_FJ=='J'">{{cliente.CPF_CNPJ | toCnpjFormatado}}</div>
                    </td>
                </tr>                




                <tr>
                    <td class="label-cadastro">Observações:</td>
                    <td class="campo-cadastro"> {{cliente.OBS}} </td>
                </tr>

            </table>
        </div>
        <div class="app-rodape">
            <div class="opcoes-cliente">
                <div v-if="cliente.TIPO_FJ=='F'" class="opcoes-client-item" @click="dependentes"><button>Dependentes</button></div>
                <div v-if="cliente.TIPO_FJ=='J'" class="opcoes-client-item" @click="contatos"><button>Contatos</button></div>
                <div class="opcoes-client-item" @click="milhagem"><button>Milhagem</button></div>
                <div class="opcoes-client-item" @click="emAberto"><button>Em aberto</button></div>
                <div class="opcoes-client-item" @click="liquidado"><button>Liquidado</button></div>
            </div>
        </div>
	</div>


</template>

<script>

import TopBar from '@/components/layout/TopBar.vue';

export default {
    name : 'Clientes',
    props: ['id'],
    components: {
        TopBar
    },

    data() {
        return {
            cliente : {}
        };        
    },
    mounted: function () {
        const codCliente = JSON.parse(atob(this.id));
        const filterClientes = this.$store.state.clientes.filter(c => {
            return c.COD_CLIENTE === codCliente
        });
        if (filterClientes.length===1)
        this.cliente = filterClientes[0]
    },

    methods : {

        dependentes(){
            var objb64 = btoa(JSON.stringify(this.cliente.COD_CLIENTE));
            this.$router.push(`/dependentescliente/${objb64}`);
        },

        milhagem(){
            var objb64 = btoa(JSON.stringify(this.cliente.COD_CLIENTE));
            this.$router.push(`/milhagemcliente/${objb64}`);
        },

        contatos(){
            var objb64 = btoa(JSON.stringify(this.cliente.COD_CLIENTE));
            this.$router.push(`/contatoscliente/${objb64}`);
        },

        emAberto(){
            var objb64 = btoa(JSON.stringify(this.cliente.COD_CLIENTE));
            this.$router.push(`/liquidadoemaberto/${objb64}/A`);
        },
        liquidado(){
            var objb64 = btoa(JSON.stringify(this.cliente.COD_CLIENTE));
            this.$router.push(`/liquidadoemaberto/${objb64}/R`);
        }

    }
    
}
</script>


<style scoped>



    .opcoes-cliente{
        width: 100%;
        --background-color: var(--dark-color);
        height: 64px;
        padding-left: 4%;
        padding-left: 4%;
    }
    
    .opcoes-client-item{
        width: 23%;
        float: left;
        text-align: center;
    }

    .opcoes-client-item button{
        background-color: var(--primary-color);
        color: white;
        border: 0px;
        height: 44px;
        margin: 10px 0;
        width: 100%;
    }

    .opcoes-client-item:nth-child(1) button{
        border-radius: 10px 0 0 10px;
    }

    .opcoes-client-item:nth-child(4) button{
        border-radius: 0 10px 10px 0;
    }    

        
    .table{
        border-collapse: collapse;
        width: calc(100% - 20px);
        margin: 20px 10px;    
        border: 1px solid var(--dark-color);    
    }

    td{
        --border-collapse: collapse;
        border: 1px solid var(--dark-color);
    }


</style>